import { useCallback, useEffect, useState } from "react";

const KEY = "rickie_splash_sound";
let ctx;
const rand = (a, b) => a + Math.random() * (b - a);

export const playSpraySound = () => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const t0 = ctx.currentTime;
    const dur = 1.5;

    const buffer = ctx.createBuffer(1, Math.floor(ctx.sampleRate * dur), ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
    const noise = ctx.createBufferSource();
    noise.buffer = buffer;
    const band = ctx.createBiquadFilter();
    band.type = "bandpass";
    band.Q.value = 0.6;
    band.frequency.setValueAtTime(4200, t0);
    band.frequency.exponentialRampToValueAtTime(700, t0 + dur);
    const high = ctx.createBiquadFilter();
    high.type = "highpass";
    high.frequency.value = 350;
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.exponentialRampToValueAtTime(0.55, t0 + 0.05);
    gain.gain.exponentialRampToValueAtTime(0.25, t0 + 0.5);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    noise.connect(band).connect(high).connect(gain).connect(ctx.destination);
    noise.start(t0);
    noise.stop(t0 + dur);

    for (let k = 0; k < 9; k++) {
      const t = t0 + 0.25 + rand(0, 1.1);
      const f = rand(1100, 2800);
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.setValueAtTime(f, t);
      osc.frequency.exponentialRampToValueAtTime(f * 0.45, t + 0.14);
      const g = ctx.createGain();
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(rand(0.05, 0.14), t + 0.008);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.16);
      osc.connect(g).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.2);
    }
  } catch (err) {
    console.warn("Splash sound unavailable:", err);
  }
};

export const useSplashSound = () => {
  const [enabled, setEnabled] = useState(() => localStorage.getItem(KEY) !== "off");
  const toggle = useCallback(() => {
    setEnabled((v) => {
      localStorage.setItem(KEY, v ? "off" : "on");
      if (!v) playSpraySound();
      return !v;
    });
  }, []);
  return [enabled, toggle];
};

export const useFirstClickSplash = (onSplash) => {
  useEffect(() => {
    const handler = () => {
      if (localStorage.getItem(KEY) !== "off") playSpraySound();
      onSplash();
    };
    window.addEventListener("pointerdown", handler, { once: true, capture: true });
    return () => window.removeEventListener("pointerdown", handler, { capture: true });
  }, [onSplash]);
};
